import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { AppConsts } from "@shared/app-consts";
import {
  AddClientRequest,
  AddClientResponse,
  ClientType,
  DeleteClientRequest,
  DeleteClientResponse,
  EditClientRequest,
  EditClientResponse,
  EInvoiceClientDto,
  EInvoiceClientListModel,
  EInvoiceClientListRequest,
} from "@shared/e-invoice";
import { BaseService } from "@services/base.service";
import { LabelValueModel } from "@shared/models/common/label-value.model";
import { EnumService } from "@services/common";

@Injectable({
  providedIn: "root",
})
export class EInvoiceClientService extends BaseService {
  // Parité V1 : retypé Subject<void> (déclencheur sans valeur — RxJS 7 exige un argument sur next() sinon).
  RefreshSubject: Subject<void> = new Subject<void>();

  constructor(private http: HttpClient) {
    super();
  }

  list(
    request: EInvoiceClientListRequest
  ): Observable<EInvoiceClientListModel> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.get(
      AppConsts.API_SERVICE_URL + "ElectronicInvoiceClient",
      httpOptions
    ) as Observable<EInvoiceClientListModel>;
  }

  item(id: number): Observable<EInvoiceClientDto> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.get(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceClient/${id}`,
      httpOptions
    ) as Observable<EInvoiceClientDto>;
  }

  add(request: AddClientRequest): Observable<AddClientResponse> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.post(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceClient`,
      request,
      httpOptions
    ) as Observable<AddClientResponse>;
  }

  edit(id: number, request: EditClientRequest): Observable<EditClientResponse> {
    let httpOptions = this.getHttpHeader(false);

    return this.http.put(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceClient/${id}`,
      request,
      httpOptions
    ) as Observable<EditClientResponse>;
  }

  delete(
    id: number,
    request: DeleteClientRequest
  ): Observable<DeleteClientResponse> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));

    return this.http.delete(
      AppConsts.API_SERVICE_URL + `ElectronicInvoiceClient/${id}`,
      httpOptions
    ) as Observable<DeleteClientResponse>;
  }

  getClientTypeName = (type: ClientType): string => {
    switch (type) {
      case ClientType.Company:
        return "Société en france";
      case ClientType.Particular:
        return "Particulier";
        case ClientType.ForeignCompany:
          return "Société à l'étranger";
      default:
        return "";
    }
  };

  getClientTypeOptions(): LabelValueModel[] {
    return EnumService.getNames(ClientType).map((key) => {
      const item = ClientType[key];
      const itemLabel = this.getClientTypeName(item);

      return new LabelValueModel(itemLabel, item);
    });
  }
}
